/**
 * Check if the page has a visible scrollbar
 * and adds a specific class to body so we can
 * adapt styles according to it.
 */
function checkWindowScrollbar() {
	if ( window.innerWidth > document.body.clientWidth + 5 ) {
		document.body.classList.add( 'has-scrollbar' );
		document.documentElement.style.setProperty( '--scroll-bar', `${ window.innerWidth - document.body.clientWidth }px` );
	}
	else {
		document.body.classList.remove( 'has-scrollbar' );
	}
}

viewport_service.on( 'change', checkWindowScrollbar );
checkWindowScrollbar();
